import React from "react";
import { Route, Routes } from "react-router-dom";

// screens
// import WorkInProgress from "../Views/Common/work-in-progress";
import NotFound404 from "../Views/Common/not-found-404";
import AccountsByEndingDate from "../Views/MainScreen/ReportsScreen/AccountsByEndingDate";
import AgentCommissionSheet from "../Views/MainScreen/ReportsScreen/AgentCommissionSheet";
import {
  BalanceSheetLoan,
  BalanceSheetDeposit,
} from "../Views/MainScreen/ReportsScreen/BalanceSheet";
import PaidUnpaidAccounts from "../Views/MainScreen/ReportsScreen/PaidUnpaidAccounts";
import PnLReport from "../Views/MainScreen/ReportsScreen/PnLReport";
import ReportsScreen from "../Views/MainScreen/ReportsScreen/ReportsScreen";

function ReportsScreenNavigator(props) {
  return (
    <ReportsScreen {...props}>
      <Routes>
        <Route path="/balancesheet/loan" element={<BalanceSheetLoan />} />
        <Route path="/balancesheet/deposit" element={<BalanceSheetDeposit />} />
        <Route path="/paid-unpaid" element={<PaidUnpaidAccounts />} />
        <Route path="/byreturningdate" element={<AccountsByEndingDate />} />
        <Route path="/agentcommission" element={<AgentCommissionSheet />} />
        <Route path="/pnl" element={<PnLReport />} />

        <Route path="*" element={<NotFound404 />} />
      </Routes>
    </ReportsScreen>
  );
}
export default ReportsScreenNavigator;
